class ProductComparisonTable extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;

    this.cacheElements();

    if (!this.scroller) return;

    this.bindEvents();
    this.initialized = true;

    window.requestAnimationFrame(() => {
      this.updateState();
    });
  }

  disconnectedCallback() {
    if (!this.initialized || !this.scroller) return;

    this.scroller.removeEventListener('scroll', this.handleScroll);
    window.removeEventListener('resize', this.updateState);
  }

  cacheElements() {
    this.scroller = this.querySelector('.product-comparison__scroll');
    this.hint = this.querySelector('.product-comparison__hint');
    this.thumb = this.querySelector('.product-comparison__scrollbar-thumb');
    this.hintKey = this.dataset.hintKey || 'product-comparison-hint';
    this.hintDismissed = this.getStoredHintState();
  }

  bindEvents() {
    this.updateState = this.updateState.bind(this);
    this.handleScroll = this.handleScroll.bind(this);
    this.hideHint = this.hideHint.bind(this);

    this.scroller.addEventListener('scroll', this.handleScroll, { passive: true });
    window.addEventListener('resize', this.updateState);
  }

  hideHint() {
    this.hintDismissed = true;
    this.storeHintState();
    this.setHintVisibility(false);
  }

  getStoredHintState() {
    try {
      return window.localStorage.getItem(this.hintKey) === 'hidden';
    } catch (error) {
      return false;
    }
  }

  storeHintState() {
    try {
      window.localStorage.setItem(this.hintKey, 'hidden');
    } catch (error) {
      /* no-op */
    }
  }

  handleScroll() {
    const hasScrolled = this.scroller.scrollLeft > 4;

    if (hasScrolled && !this.hintDismissed) {
      this.hideHint();
    }

    this.updateScrollbarThumb(this.scroller.scrollWidth > this.scroller.clientWidth + 4);
  }

  updateState() {
    const overflow = this.scroller.scrollWidth > this.scroller.clientWidth + 4;
    const isMobile = window.matchMedia('(max-width: 767.98px)').matches;

    const showHint = overflow && isMobile && !this.hintDismissed;
    this.setHintVisibility(showHint);

    this.updateScrollbarThumb(overflow);
  }

  setHintVisibility(isVisible) {
    if (!this.hint) return;

    this.hint.classList.toggle('is-visible', isVisible);
    this.hint.classList.toggle('is-hidden', !isVisible);
  }

  updateScrollbarThumb(hasOverflow) {
    if (!this.thumb || !hasOverflow) {
      if (this.thumb) this.thumb.style.width = '100%';
      return;
    }

    const ratio = this.scroller.clientWidth / this.scroller.scrollWidth;
    const maxScroll = this.scroller.scrollWidth - this.scroller.clientWidth;
    const progress = maxScroll > 0 ? this.scroller.scrollLeft / maxScroll : 0;
    const trackWidth = this.thumb.parentElement.clientWidth;
    const thumbWidth = Math.max(trackWidth * ratio, 48);
    const travel = trackWidth - thumbWidth;

    this.thumb.style.width = `${thumbWidth}px`;
    this.thumb.style.transform = `translateX(${travel * progress}px)`;
  }
}

if (!customElements.get('product-comparison-table')) {
  customElements.define('product-comparison-table', ProductComparisonTable);
}
